export default __webpack_public_path__ + "static/core-values-474fb7b792feb5aa4ade18525334c451.png";